// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { generateId, mobileView } from '../../_common/api/utility';
import Button from '../../_common/form/Button';
import Heading from '../../_common/form/Heading';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import GoogleMap from '../../_common/GoogleMap';
import Loading from '../../_common/Loading';
import Modal from '../../_common/Modal';
import ScrollShadow from '../../_common/ScrollShadow';
import Page from '../pageLayout/Page';
import { HamQuest } from '../../../App';

const GMap = styled(GoogleMap)`
    width: 50%;
    min-width: 500px;
    height: 500px;

    ${({ mobile }) => mobile && `
        min-width: unset;
        width: 80vw;
        height: 80vw;
    `}
`
const Wrapper = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
`

const LocList = styled(ScrollShadow)`
    max-height: 50vh;
    overflow: auto;
    padding: 0 2em;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
`
const Line = styled.div`
    width: 95%;
    margin: 0.5rem 0;
    border-width: 2px 0px 0px;
    border-top-style: solid;
    border-top-color: ${({ theme }) => theme.secondary};
`
const Span = styled.span`
    font-size: 0.7em;
`

const Locations = () => {
    const {
        state: {
            // mobileView,
        },
    } = useGlobalState();

    const [loc, setLoc] = useState({
        center: {
            lat: 41.61487724999999,
            lng: -83.64443975
        },
        zoom: 12,
    });

    useEffect(() => {
        HamQuest.get(QuestRoute.locations, { cache: 'force-cache' })
            .then((res) => setLoc({
                ...loc,
                markers: res
            }))
    }, [])

    const handleClick = (e) => {
        const address = `https://www.google.com/maps/dir/?api=1&destination=${e.address1 + ' ' + (e.address2 || '')}, ${e.city}` + (e.state ? (',' + e.state) : '') + (e.zip ? (',' + e.zip) : '');
        Modal.Show({
            title: 'Car Wash',
            body: e.address1,
            buttons: [
                <Button
                    key={generateId()}
                    href={address}
                    target='_blank'
                >Directions</Button>
            ]
        })
    }

    const centerMap = e => {
        setLoc({
            ...loc,
            center: {
                lat: e.latitude,
                lng: e.longitude
            }
        })
    }

    if (!loc.markers) return <Loading />

    const locations = loc.markers.length;

    return (
        <Page>
            <Title icon='map'>{locations > 1 ? `Visit any of our ${loc.markers.length} locations!` : 'Visit us!'}</Title>
            <Wrapper>
                <GMap
                    mobile={mobileView}
                    config={loc}
                    markerClick={handleClick}
                />
                <LocList
                    mobile={mobileView}
                >
                    {
                        loc.markers.map((e, i) =>
                            <div key={generateId()}>
                                <Col onClick={() => centerMap(e)}>
                                    <Heading>{e.city}</Heading>
                                    <Button icon='directions' onClick={() => handleClick(e)}>Directions</Button>
                                    {e.phone ? <span><b>Phone</b>: {e.phone}</span> : null}
                                    <Span><b>Address</b>: <div>{`${[e.address1, (e.address2 || false)].filter(Boolean).join(' ')}, ${[e.city, e.state, e.zip].filter(Boolean).join(', ')}`}</div></Span>
                                </Col>
                                {i !== locations - 1 ? <Line /> : null}
                            </div>
                        )
                    }
                </LocList>
            </Wrapper>
        </Page>
    );
}

export default Locations